import { AppState } from 'core/redux/reducers';
// import { hot } from 'react-hot-loader/root'
import { connect } from 'react-redux';
import React, { Component } from 'react';
import FormStepContainer from '../Components/FormStepContainer';
import { Column } from 'Components/Elements/Layouts';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import Summary from '../Components/Summary';
import BookingNextLoading from '../Components/BookingNextLoading';

const mapStateToProps = (state: AppState) => ({
  paymentUrl: state.booking.order.payment_url,
});

const mapDispatchToProps = {};

type TProps = RouteComponentProps<{ step: string }> &
  ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps;

let isRedirecting = false;

class Step4Comp extends Component<TProps> {
  componentDidUpdate(
    prevProps: Readonly<TProps>,
    prevState: Readonly<{}>,
    snapshot?: any,
  ): void {
    const {
      props: { paymentUrl },
    } = this;
    if (paymentUrl && !isRedirecting) {
      isRedirecting = true;
      setTimeout(_ => {
        window.location.href = paymentUrl;
      }, 1000);
    }
  }

  render() {
    return (
      <FormStepContainer id="book-step4" hideButtons={true}>
        <Column
          className="checkout__content__items checkout--right-border is-flex-mid eb-booking-terms"
          size={['8-tablet']}
        >
          <BookingNextLoading hide={false} />
        </Column>
        <Column
          className="checkout__content__summary checkout__content__items checkout--bg-blue"
          size={'4'}
        >
          <Summary />
        </Column>
      </FormStepContainer>
    );
  }
}

// const StepsRoot =
//   process.env.NODE_ENV !== 'production' ? hot(Step4Comp) : Step4Comp;
const Step4 = connect(mapStateToProps, mapDispatchToProps)(Step4Comp);
export default withRouter(Step4);
